import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { ThemeProvider } from '@aws-amplify/ui-react';
import { FaceLivenessDetector } from '@aws-amplify/ui-react-liveness';
import '@aws-amplify/ui-react/styles.css';
function notifyHost(event, payload) {
    if (window.flutter_inappwebview?.callHandler) {
        window.flutter_inappwebview.callHandler(event, payload).catch(() => {
            /* swallow — the host bridge may not be ready if dev-loaded */
        });
        return;
    }
    const message = JSON.stringify({ type: event, payload });
    if (window.ReactNativeWebView?.postMessage) {
        window.ReactNativeWebView.postMessage(message);
        return;
    }
    window.parent?.postMessage({ type: event, payload }, '*');
}
export default function App() {
    const [status, setStatus] = useState('loading');
    const [errorMessage, setErrorMessage] = useState('');
    const params = useMemo(() => new URLSearchParams(window.location.search), []);
    const sessionId = params.get('sessionId') || '';
    const region = params.get('region') || import.meta.env.VITE_LIVENESS_REGION || 'eu-west-1';
    useEffect(() => {
        if (!sessionId) {
            setStatus('error');
            setErrorMessage('Missing sessionId');
            notifyHost('livenessError', { message: 'Missing sessionId' });
            return;
        }
        setStatus('running');
    }, [sessionId]);
    if (status === 'loading') {
        return _jsx(Centered, { children: "Loading\u2026" });
    }
    if (status === 'error') {
        return _jsxs(Centered, { children: ["Error: ", errorMessage] });
    }
    if (status === 'completed') {
        return _jsx(Centered, { children: "Done. You can close this window." });
    }
    return (_jsx(ThemeProvider, { children: _jsx("div", { style: { height: '100dvh', width: '100vw', background: '#000' }, children: _jsx(FaceLivenessDetector, { sessionId: sessionId, region: region, disableStartScreen: false, onAnalysisComplete: async () => {
                    setStatus('completed');
                    notifyHost('livenessComplete', { sessionId });
                }, onError: (err) => {
                    const message = err?.error?.message || 'Liveness check failed';
                    setErrorMessage(message);
                    setStatus('error');
                    notifyHost('livenessError', { message });
                }, onUserCancel: () => {
                    notifyHost('livenessCancel', {});
                } }) }) }));
}
function Centered({ children }) {
    return (_jsx("div", { style: {
            height: '100dvh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            textAlign: 'center',
            fontSize: 16,
        }, children: children }));
}
